import Vue from 'vue';
import Vuetify from 'vuetify';
import { env } from '@/env';

Vue.use(Vuetify);

import en from 'vuetify/src/locale/en';
import es from 'vuetify/src/locale/es';
import pt from 'vuetify/src/locale/pt';

const enLocale = {
  ...en,
  dataTable: {
    ...en.dataTable,
    itemsPerPageText: 'Rows per page:',
    pageText: '{0}-{1} of {2}',
  },
  dataFooter: {
    ...en.dataFooter,
    itemsPerPageText: 'Rows per page:',
    pageText: '{0}-{1} of {2}',
  },
};

const esLocale = {
  ...es,
  dataTable: {
    ...es.dataTable,
    itemsPerPageText: 'Filas por página:',
    pageText: '{0}-{1} de {2}',
  },
  dataFooter: {
    ...es.dataFooter,
    itemsPerPageText: 'Filas por página:',
    pageText: '{0}-{1} de {2}',
  },
};

const opts: any = {
  lang: {
    locales: { en: enLocale, es: esLocale, pt },
    current: env.i18nLocale
  },
  theme: {
    themes: {
      light: {
        primary: '#016a7f',
        secondary: '#c0ebf2',
        accent: '#016a7f',
        error: '#ed1c24',
        info: '#363636',
        success: '#72bf74',
        warning: '#faa61a',
        repsolOrange: '#ff6600',
        repsolLightGrey: 'fafafa',
        repsolGreen: '#016a7f',
        repsolLigthGreen: '#c0ebf2',
        repsolGrey: '#848484',
        repsolTitle: '#4b4b4b',
        repsolDarkGrey: '#363636',
        repsolMediumGray: '#aaa',
        repsolBlack: '#000000'
      }
    }
  },
  options: {
    customProperties: false
  },
  icons: {
    iconfont: 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
};

export default new Vuetify(opts);
